const currentLanguage = (windowObject, cookieLocale) => {
  return () => {
    const queryParams = windowObject.location.search.substr(1).split('&');

    let language = 'en';
    queryParams.forEach((param) => {
      if (param.match(/locale=/i)) {
        language = param.split('=')[1];
      }
    })

    if (cookieLocale) {
      language = cookieLocale
    }

    return language;
  }
}

const changeLanguage = (windowObject) => {
  const currentUrl = windowObject.location.pathname;
  return (language) => {
    const currentParamParts = windowObject.location.search.substr(1).split('&');

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'gtm.languageSelect',
      locale: language,
    });

    let newParamParts = [];
    currentParamParts.forEach(function (param) {
      if (param != '' && !param.match(/locale=/i)) {
        newParamParts.push(param);
      }
    });

    let currentParams = newParamParts.join('&');
    let newParamPrefix = '&';

    if (currentParams == '') {
      newParamPrefix = '?';
    } else {
      currentParams = '?' + currentParams;
    }

    const newParam = 'locale=' + language;
    windowObject.location = currentUrl + currentParams + newParamPrefix + newParam;
  }
}

export {
  currentLanguage,
  changeLanguage
}
